import tent1 from "../images/tents/tent1.png";
import tent2 from "../images/tents/tent2.png";
import tent3 from "../images/tents/tent3.png";
import tent4 from "../images/tents/tent4.png";
import tent5 from "../images/tents/tent5.png";
import tent6 from "../images/tents/tent6.png";
import tent7 from "../images/tents/tent7.png";
import tent8 from "../images/tents/tent8.png";
import tent9 from "../images/tents/tent9.png";
import tent10 from "../images/tents/tent10.png";
import tent11 from "../images/tents/tent11.png";
import tent12 from "../images/tents/tent12.png";

const tents = [
  {
    category: "tents",
    id: "tent1",
    name: "Base Camper 6-Person Tent",
    price: 469,
    image: `${tent1}`,
  },
  {
    category: "tents",
    id: "tent2",
    name: "Spark 2.0 3-Person Tent",
    price: 519,
    image: `${tent2}`,
  },
  {
    category: "tents",
    id: "tent3",
    name: "Wawona 6-Person Tent",
    price: 699.00,
    image: `${tent3}`,
  },
  {
    category: "tents",
    id: "tent4",
    name: "Super Dome 4-Person Tent",
    price: 459.00,
    image: `${tent4}`,
  },
  {
    category: "tents",
    id: "tent5",
    name: "Aurora 3-Person Tent",
    price: 459.00,
    image: `${tent5}`,
  },
  {
    category: "tents",
    id: "tent6",
    name: "Midori Solo 1-Person Tent",
    price: 179.00,
    image: `${tent6}`,
  },
  {
    category: "tents",
    id: "tent7",
    name: "Midori 3-Person Tent",
    price: 319.00,
    image: `${tent7}`,
  },
  {
    category: "tents",
    id: "tent8",
    name: "Hubba Hubba 3-Person Tent",
    price: 699.00,
    image: `${tent8}`,
  },
  {
    category: "tents",
    id: "tent9",
    name: "Suma 3-Person Tent",
    price: 249.00,
    image: `${tent9}`,
  },
  {
    category: "tents",
    id: "tent10",
    name: "El Capitan 4-Person Tent",
    price: 479.00,
    image: `${tent10}`,
  },
  {
    category: "tents",
    id: "tent11",
    name: "Camper 2-Person Tent",
    price: 279.00,
    image: `${tent11}`,
  },
  {
    category: "tents",
    id: "tent12",
    name: "Cabin 2.0 4-Person Tent",
    price: 549.00,
    image: `${tent12}`,
  },
];

export default tents;
